<template>
  <div class="row justify-content-center">
    <div class="col col-md-6 mt-4">
      <div class="card mb-4">
        <div class="card-header bg-info text-light">
          Reset Password
        </div>
        <div class="card-body">
          <form v-if="formStatus.success !== true" @submit.prevent="submit" class="needs-validation">
            <fieldset class="form-group">
              <label for="email">Email Address</label>
              <input v-model="credential.email" type="text" readonly disabled class="form-control" id="email" name="email">
            </fieldset>
            <fieldset v-if="!showFormSelectorg" class="form-group">
              <label for="password">Password</label>
              <input v-model="credential.password" type="password" :class="['form-control', { 'is-invalid':validationErrors.password }]" id="password" name="password">
              <div class="invalid-feedback" v-if="validationErrors.password" v-text="validationErrors.password"></div>
            </fieldset>
            <fieldset v-if="!showFormSelectorg" class="form-group">
              <label for="password_confirm">Confirm Password</label>
              <input v-model="password_confirm" type="password" :class="['form-control', { 'is-invalid':validationErrors.password_confirm }]" id="password_confirm" name="password_confirm">
              <div class="invalid-feedback" v-if="validationErrors.password_confirm" v-text="validationErrors.password_confirm"></div>
            </fieldset>
            <fieldset v-if="showFormSelectorg" class="form-group">
              <label for="selectorg">Organization</label>
              <select v-model="credential.orgid" :class="['form-control', { 'is-invalid':validationErrors.selectorg }]" id="selectorg" name="selectorg">
                <option v-for="org in selectorg" :key="org.id" :value="org.id">
                  {{org.name}}
                </option>
              </select>
              <div class="invalid-feedback" v-if="validationErrors.selectorg" v-text="validationErrors.selectorg"></div>
            </fieldset>
            <button v-if="!showFormStatusMessage" type="submit" class="btn btn-primary">
              {{ showFormSelectorg ? "Login" : "Update" }}
            </button>
          </form>
          <div v-if="showFormStatusMessage" :class="['alert', { 'alert-success':formStatus.success, 'alert-danger':formStatus.error }, 'alert-dismissible']" role="alert" style="margin-top:20px">
            <h4 class="alert-heading" v-html="formStatus.statusHeading"></h4>
            <p v-html="formStatus.statusBody"></p>
            <button @click="clearFormStatus()" type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
// import router from '@/router'
import LoginCredential from '@/structs/LoginCredential'

export default {
  name: 'ResetPasswordPage',
  data () {
    return {
      password_confirm: null,
      credential: new LoginCredential(),
      selectorg: [],
      validationErrors: {
        password: null,
        password_confirm: null
      },
      formStatus: {
        success: null,
        error: null,
        statusHeading: null,
        statusBody: null
      }
    }
  },
  computed: {
    showFormStatusMessage () {
      return this.formStatus.success || this.formStatus.error
    },
    showFormSelectorg () {
      return !!this.selectorg.length > 0
    }
  },
  created () {
    this.validateToken({ token: this.$route.params.token })
      .then(data => { this.credential.email = data.email })
      .catch(err => {
        console.log(err)
        this.markError(err.message || 'Invalid password reset link.  Redirecting to Login.')
        // setTimeout(() => { router.push({ name: 'login' }) }, 3000)
      })
  },
  methods: {
    ...mapActions('auth', ['validateToken', 'completeResetRequest', 'login']),
    submit () {
      var self = this
      if (this.validateForm()) {
        if (this.showFormSelectorg) {
          // they submitted after selecting an org
          // attempt login using new password and selected orgid
          this.login(this.credential)
            .catch(response => { self.markError(response.message) })
        } else {
          // they submitted password and password confirm
          // attempt login using new password
          this.completeResetRequest({ token: this.$route.params.token, password: this.credential.password })
            .then(response => {
              if (response.data && response.data.selectorg && response.data.selectorg.length > 0) {
                self.selectorg = response.data.selectorg
              } else {
                return self.login(self.credential)
              }
            })
            .catch(response => {
              console.log(response)
              self.markError(response.message)
            })
        }
      }
    },
    clearFormStatus () {
      this.formStatus.success = null
      this.formStatus.error = null
      this.statusHeading = null
      this.statusBody = null
    },
    markSuccess () {
      this.clearFormStatus()

      this.formStatus.statusHeading = 'Success!'
      this.formStatus.statusBody = 'Your password has been reset.  You will now be logged in.'
      this.formStatus.success = true
    },
    markError (message) {
      console.log(message)
      this.clearFormStatus()

      this.formStatus.statusHeading = 'Error'
      this.formStatus.statusBody = (message || 'Unable to reset password.')
      this.formStatus.error = true
    },
    clearValidationErrors () {
      this.validationErrors.userid = null
      this.validationErrors.password = null
    },
    validateForm () {
      this.clearValidationErrors()

      if ((this.credential.password || '') === '') {
        this.validationErrors.password = 'Empty or invalid password'
        return false
      }

      if ((this.password_confirm || '') === '') {
        this.validationErrors.password_confirm = 'Empty or invalid password confirm'
        return false
      }

      if (this.credential.password !== this.password_confirm) {
        this.validationErrors.password = 'Passwords must match'
        this.validationErrors.password_confirm = 'Passwords must match'
        return false
      }

      if (this.credential.password.length < 6) {
        this.validationErrors.password_confirm = 'Passwords must be at least 6 characters'
        return false
      }

      return true
    }
  }
}

</script>
